import Link from "next/link";
import { ModeIds } from "@chesshotel/constants";
import { BulletIcon } from "@/icons/BulletIcon";
import {
  FaBolt,
  FaDragon,
  FaDiceSix,
  FaPaperPlane,
  FaPuzzlePiece,
} from "react-icons/fa";
import useTranslation from "next-translate/useTranslation";
import { getModeNameCapitalFirst } from "@/util/util";
import styles from "../profile/Profile.module.css";

export default function LeaguesHeader({ activeMode = ModeIds.BULLET }) {
  const { t } = useTranslation("common");
  const modes = [
    [ModeIds.BULLET, BulletIcon],
    [ModeIds.BLITZ, FaBolt],
    [ModeIds.RAPID, FaDragon],
    [ModeIds.CHESS960, FaDiceSix],
    [ModeIds.DAILY, FaPaperPlane],
    [ModeIds.PUZZLE, FaPuzzlePiece],
  ] as const;
  return (
    <nav className={styles.sidebar} aria-label={t("Leagues")}>
      <div className={styles.menu}>
        {modes.map(([mode, Icon]) => (
          <Link
            key={mode}
            href={`/leagues/${mode}`}
            aria-current={activeMode === mode ? "page" : undefined}
            className={`${styles.sidebarItem} ${
              activeMode === mode ? styles.active : ""
            }`}
          >
            <span className={styles.icon}>
              <Icon aria-hidden="true" />
            </span>
            <span>
              {mode === ModeIds.PUZZLE
                ? t("Puzzles")
                : getModeNameCapitalFirst(mode, t)}
            </span>
          </Link>
        ))}
      </div>
    </nav>
  );
}
